import TermsAccept from "../../components/terms/TermsAccept";
import TermsList from "../../components/terms/TermsList";
import mergeStore from "../../libs/tools/MergeStore";
import terms_store from "../../store/terms";
import termsService from "../../libs/api/services/TermsServiceApi";

export default {
  install(Vue, { store, store_override = {}, is_site = true }) {
    if (!store) {
      throw new Error("you should provide Vuex store");
    }
    if (!window.api) {
      throw new Error("NO API!");
    }
    if (!window.api.termsService) {
      window.api.registerService(termsService.name, termsService);
    }
    const store_module = mergeStore(terms_store, store_override);
    Vue.component("termsaccept", TermsAccept);
    if (is_site) {
      Vue.component("termslist", TermsList);
    }
    store.registerModule("terms", store_module);
  },
};
